import { HttpMethod, Performer } from './core'

export class SyncTaps extends Performer<{ payload: { taps: number } }, { balance: bigint }> {
  protected method = HttpMethod.POST
  protected url = '/sync-taps'
}
